// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import ThemeController from "./theme_controller"
import DropdownController from "./dropdown_controller"
import MobileMenuController from "./mobile_menu_controller"
import VideoController from "./video_controller"
import CarouselController from "./carousel_controller"
import AccordionController from "./accordion_controller"
import ScrollSpyController from "./scroll_spy_controller"

application.register("hello", HelloController)
application.register("theme", ThemeController)
application.register("dropdown", DropdownController)
application.register("mobile-menu", MobileMenuController)
application.register("video", VideoController)
application.register("carousel", CarouselController)
application.register("accordion", AccordionController)
application.register("scroll-spy", ScrollSpyController)